module.exports = __webpack_public_path__ + "img/logo.211b87d5.svg";